import { h } from "../../../../tracejs/src/utils/JSXFactory";
import { injectable } from "tsyringe";

import { IDestinationSettings } from "./IDestinationSettings";
import { BaseWidgetSettings } from "../../common/BaseWidgetSettings";

/**
 * Track and Trace Settings
 */
@injectable()
export class DestinationSettings extends BaseWidgetSettings<IDestinationSettings>
{

    /**
     * Settings template
     * @returns 
     */
    public dialogTemplate = (): HTMLElement => (
        <div data-bind="with: $root.settings.widgetSettings">
            <div class="row">
                <div class="col-md-4">
                    <div className="row mb-2">
                        <label className="inline col-md-6 col-form-label" data-bind="uniqueFor: 'etaMinus'">EDL minus (days)</label>
                        <div className="col-md-6">
                            <input type="number" className="form-control" data-bind="value: filters.etaMinus, uniqueId: 'etaMinus'" />
                        </div>
                    </div>
                    <div className="row mb-2">
                        <label className="inline col-md-6 col-form-label" data-bind="uniqueFor: 'etaPlus'">EDL plus (days)</label>
                        <div className="col-md-6">
                            <input type="number" className="form-control" data-bind="value: filters.etaPlus, uniqueId: 'etaPlus'" />
                        </div>
                    </div>
                    <div className="row mb-2">
                        <label className="inline col-md-6 col-form-label" data-bind="uniqueFor: 'ataPlus'">ADL plus (days)</label>
                        <div className="col-md-6">
                            <input type="number" className="form-control" data-bind="value: filters.ataPlus, uniqueId: 'ataPlus'" />
                        </div>
                    </div>
                </div>
                <div class="col-md-8">

                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" data-bind="checked: filters.showEmergency, uniqueId: 'showEmergency'" />
                        <label class="form-check-label" data-bind="uniqueFor: 'showEmergency'"><span data-bind="i18n: 'widget.destination.showEmergency'"></span></label>
                    </div>

                </div>
            </div>

            <hr />

            <fieldset>
                <legend data-bind="i18n: 'widget.destination.colors'"></legend>
                <ul>
                    <li data-bind="i18n: 'widget.destination.descrWhite'"></li>
                    <li data-bind="i18n: 'widget.destination.descrGreen'"></li>
                    <li data-bind="i18n: 'widget.destination.descrOrange'"></li>
                    <li data-bind="i18n: 'widget.destination.descrRed'"></li>
                </ul>
            </fieldset>

            <fieldset>
                <legend data-bind="i18n: 'common.captions.description'"></legend>
                <p data-bind="i18n: 'widget.destination.descr'"></p>
            </fieldset>

            <fieldset>
                <legend data-bind="i18n: 'common.captions.notePractice'"></legend>
                <p data-bind="i18n: 'widget.destination.descr2'"></p>
            </fieldset>

        </div>
    );

}